import { FC } from "react";
import StoreGrid from "./StoreGrid";

export const StoreGridDetail : FC<IGridProps> = (props) => {
    return <StoreGrid isDetail={true} {...props}></StoreGrid>
}